// extracted by mini-css-extract-plugin
export default {"font-renta":"ArsenalPageRow_font-renta__sRwb-","arsenalPageRow":"ArsenalPageRow_arsenalPageRow__nXmy4"};